/**
 * Estilo de una celda del listado de devoluciones según su columna (alineación y corte de texto).
 * @param {{align?: string, wrap?: boolean}} column Columna de `RETURN_TABLE_COLUMNS`.
 * @returns {Object} `sx` de la celda.
 */
export const getReturnCellSx = (column) => ({
  textAlign: column.align || 'left',
  px: 1.5,
  py: 1,
  fontSize: 13,
  verticalAlign: 'middle',
  '&&': {
    whiteSpace: column.wrap ? 'normal' : 'nowrap',
    overflowWrap: column.wrap ? 'anywhere' : undefined,
    textOverflow: 'clip',
  },
});
